"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Buttons = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _constants = require("../../constants");

var _app = require("../../store/actions/app");

var _traffic = require("../../store/actions/traffic");

var _conversation = require("../../store/actions/conversation");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Buttons =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Buttons, _PureComponent);

  function Buttons(props) {
    var _this;

    _classCallCheck(this, Buttons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Buttons).call(this, props));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Buttons, [{
    key: "handleClickLink",
    value: function handleClickLink(url) {
      // eslint-disable-next-line no-console
      console.log('Button Link Clicked: ', url); // trafficManager.sendLinkClickEvent('button', this.props.intent, this.props.sessionId, url);
    }
  }, {
    key: "onClick",
    value: function onClick(evt, item) {
      var event = item.event,
          label = item.label;
      evt.stopPropagation();
      this.props.appScrolledSet(true);
      this.props.conversationAppend({
        items: [label],
        type: _constants.CONVERSATION_TYPE_UTTERANCE
      });
      this.props.conversationSend('', event);
      this.props.trafficBotActionButtonClick({
        text: label
      });
      this.props.trafficSurveyQuestionAnswered(label);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var items = this.props.items;
      return _react["default"].createElement(_react.Fragment, null, items.map(function (item, index) {
        return _react["default"].createElement("div", {
          key: index,
          className: "jsx-2236040659" + " " + 'chatbot-button-container'
        }, item.link ? _react["default"].createElement("a", {
          onClick: function onClick() {
            return _this2.handleClickLink(item.link);
          },
          href: item.link,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "jsx-2236040659" + " " + 'chatbot-button bd-info'
        }, item.label) : _react["default"].createElement("button", {
          disabled: !item.enabled,
          onClick: function onClick(evt) {
            return _this2.onClick(evt, item);
          },
          "data-event": item.event,
          className: "jsx-2236040659" + " " + 'chatbot-button bd-info'
        }, item.label));
      }), _react["default"].createElement(_style["default"], {
        id: "2236040659"
      }, ".chatbot-button-container.jsx-2236040659{padding-left:25px;}.chatbot-button-container.jsx-2236040659:not(:first-child){margin-top:6px;}.chatbot-button.jsx-2236040659{background-color:#FFF;border-color:#9E9E9E;border-radius:25px;border-style:solid;border-width:1px;color:#1976D2;cursor:pointer;display:block;font-size:15px;max-width:350px;outline:none;overflow-wrap:break-word;padding:8px 18px;text-align:left;width:100%;}.chatbot-button.jsx-2236040659:disabled{cursor:not-allowed;opacity:0.4;}.chatbot-button.jsx-2236040659:hover{box-shadow:0 0 10px #D3D3D3;}"));
    }
  }]);

  return Buttons;
}(_react.PureComponent);

exports.Buttons = Buttons;
Buttons.propTypes = {
  appScrolledSet: _propTypes["default"].func.isRequired,
  conversationSend: _propTypes["default"].func.isRequired,
  conversationAppend: _propTypes["default"].func.isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  trafficBotActionButtonClick: _propTypes["default"].func.isRequired,
  trafficSurveyQuestionAnswered: _propTypes["default"].func.isRequired
};
var mapDispatchToProps = {
  appScrolledSet: _app.appScrolledSet,
  conversationSend: _conversation.conversationSend,
  conversationAppend: _conversation.conversationAppend,
  trafficBotActionButtonClick: _traffic.trafficBotActionButtonClick,
  trafficSurveyQuestionAnswered: _traffic.trafficSurveyQuestionAnswered
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Buttons);

exports["default"] = _default;